<template>
  <div id="home" style="overflow-x: hidden">
    <el-form label-position="left" label-width="150px">
      <div style="background-color: white; padding: 30px;">
        <el-row class="rowtop">
          <el-col :span="12">
            <el-form-item label="默认开发票类型：" style="margin-bottom: 0; margin-left: 1rem">
              <el-radio-group v-model="invoicingType">
                <el-radio v-for="item in invoicingTypeOption" :key="item.value" :label="item.value">{{item.label}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="rowtop">
          <el-col :span="12">
            <el-form-item label="开票主体：" prop="prePay" style="margin-bottom: 0; margin-left: 1rem">
              <el-select style="margin-left: 0px" v-model="invoicingTitle" placeholder="请选择">
                <el-option v-for="item in invoicingTitleOption" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="dialog-footer">
          <el-button class="button_style" @click="saveInvoicesConfig">{{ $t("REFUNDREQUESTINFO.SUBMIT") }}</el-button>
        </div>
      </div>
    </el-form>
    <ConfirmBoxs
      :centerDialogVisible="confirmFlag"
      :confirmMsg="confirmMsg"
      :icon="confirmIcon"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>
<script>
import { hideElement } from "@/utils/utils.js";
import { searchInvoiceConfig,saveInvoiceConfig } from "@/api/bookingData";
import ConfirmBoxs from "@/components/confirmBoxs.vue";
export default {
  name: "invoicesConfig",
  components: {
    ConfirmBoxs,
  },
  data() {
    return {
      invoicingType:1,
      invoicingTypeOption:[
        { value: 1, label: "增值税普通发票",},
        { value: 2, label: "增值税专用发票",},
      ],
      invoicingTitle:1,
      invoicingTitleOption:[
        { value: 1, label: "中航嘉信商务旅行管理有限公司",},
        { value: 2, label: "中航嘉信商务旅行管理有限公司上海分公司",},
      ],
      confirmIcon: "",
      confirmFlag: false,
      confirmMsg: "",
      id:0,
    };
  },
  computed: {
    
  },
  watch: {},
  mounted() {
    //判断来源 CRM跳转过来隐藏部分元素
    hideElement(this);
    this.search();
    //this.$route.query.customerCode
  },
  methods: {
    search(){
        let customerParam = {
        params: {
          customerCode: this.$route.query.customerCode,
        },
      };
      searchInvoiceConfig(customerParam)
        .then((res) => {
            if(res.code == 200){
              if (res.data.list.length > 0) {
                this.invoicingType = res.data.list[0].defaultInvoiceType;
                this.invoicingTitle = res.data.list[0].billingBody;
                this.id = res.data.list[0].id
              }
            }
        })
    },
    saveInvoicesConfig(){
      let Param = {
        id:this.id,
        customerCode: this.$route.query.customerCode,
        defaultInvoiceType: this.invoicingType,
        billingBody:this.invoicingTitle,
      };
      saveInvoiceConfig(Param)
        .then((res) => {
          if(res.code == 200){
            this.confirmFlag = true;
            this.confirmMsg = "保存成功";
          }else{
            this.confirmFlag = true;
            this.confirmMsg = "保存失败";
          }
          this.search()
        })
    },
    setConfirmFlag(value) {
      this.confirmFlag = value;
    },
  },
};
</script>
<style scoped>
.rowtop{
    padding-bottom: 10px;
}
.button_style {
  background-color: #FF694B;
  color: #fff;
}
.dialog-footer {
    text-align: center;
    padding-top: 15px;
  }
</style>
